import axios from '../../mainConfig/axiosConfig' 
//export function checkMobiles(rule,value,callback){}
//import {checkMobiles,checkStudentID,checkUsername} from '@/components/work/until/vaildate.js'

//手机号校验
export function checkMobiles(rule, value, callback) {
   let reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
   if (!reg.test(value)) {
      callback(new Error("请正确填写您的手机号码"))
   } else {
      callback();
   }
}
//学生ID校验
export function checkStudentID(rule, value, callback) {
   let reg = /^[0-9]{9}$/;
   if (!reg.test(value)) {
      callback(new Error("由九位数字组成"))
   } else {
      axios.post("/user/getUserByStudentID?studentID=" + value)
         .then(resp => {
            if (resp.data.status == 1) {
               callback();
            } else {
               callback(new Error("学生ID不存在"))
            }
         })
   }
}

export function checkUsername(rule, value, callback) {
   axios.post("/user/login?username=" + value)
      .then(resp => {
         if (resp.data.status != 1) {
            let reg = /^[a-zA-Z0-9_-]{4,16}$/;
            if (!reg.test(value)) {
               callback(new Error("用户名由4到16位字母，数字，下划线，减号组成"))
            } else {
               callback();
            }
         } else {
            callback(new Error("用户名重复"))
         }
      })
      .catch((err) => {
         alert("出错了")
         console.log(err)
      })
}


export function checkPassword(rule, value, callback) {
            let reg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{8,50}$/;
            if (!reg.test(value)) {
               callback(new Error("密码必须包含字母、数字,特殊符号，且长度至少为8个字符"))
            } else {
               callback();
            }
}

export function checkEmail(rule,value,callback){
      if (value !== '') { 
            var reg=/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        if(!reg.test(value)){
          callback(new Error('请输入有效的邮箱'));
        }
      callback();
    }

}

export function getUsername(rule, value, callback) {
       axios.post("/user/login?username=" + value)
          .then(resp => {
             if (resp.data.status == 1) {
        console.log(resp.data.result)
                let reg = /^[a-zA-Z0-9_-]{4,16}$/;
                if (!reg.test(value)) {
                   callback(new Error("用户名由4到16位字母，数字，下划线，减号组成"))
                } else {
                   callback();
                }
             } else {
                callback(new Error("用户名不存在"))
             }
          })
          .catch((err) => {
             alert("出错了")
             console.log(err)
          })
    }


   


// WEBPACK FOOTER //
// ./src/components/work/until/vaildate.js